export default {
  buttons: {
    remove: 'Elimină',
  },
  title: 'Cod promoțional sau card cadou',
};
